import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

export const getInvoiceItemDescriptionData = async (templateId: string, jobId: string): Promise<any> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get(`https://${apiURL}/InvoiceTemplate/${templateId}/job/${jobId}`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data = response.data;
   console.log(data)
   return data;
};